import { Injectable } from '@angular/core';
import { PersonApiSharedService } from '@crm/shared/persons';
import { PersonIdByServiceId, ThreadList } from '../types';
import { Observable, of, Subscription } from 'rxjs';

@Injectable()
export class WhatsappNotifierService {
  private personIdByThreadId = new Map<number, number>();
  private personIdsByServiceIdsSubscription: Subscription;

  constructor(private personApi: PersonApiSharedService) {}

  mapThreadIds(threadList: ThreadList[]): void {
    const educationServiceIds = threadList.map(thread => thread.serviceIds[0]).filter(Boolean); // take the first element since each serviceId will return the same personId
    this.personIdsByServiceIdsSubscription?.unsubscribe();
    this.personIdsByServiceIdsSubscription = (
      educationServiceIds.length > 0 ? this.fetchPersonIdsByServiceIds(educationServiceIds) : of([])
    ).subscribe(personIdsByServiceIds => {
      personIdsByServiceIds.forEach(personIdByServiceId => {
        const threadIdByService = threadList.find(
          threadList => threadList.serviceIds[0] === personIdByServiceId.educationServiceId,
        )?.threadId;
        if (threadIdByService) {
          this.personIdByThreadId.set(threadIdByService, personIdByServiceId.personId);
        }
      });
    });
  }

  getPersonIdByThreadId(threadId: number): number {
    return this.personIdByThreadId.get(threadId);
  }

  private fetchPersonIdsByServiceIds(educationServiceIds: number[]): Observable<PersonIdByServiceId[]> {
    return this.personApi.getPersonIdsByServiceIds(educationServiceIds);
  }
}
